export * from './card.module';
export * from './card.component';


// WEBPACK FOOTER //
// /app/src/app/layout/card/index.ts